import PropTypes from 'prop-types';

export const columnSizePropType = PropTypes.oneOfType([
  PropTypes.number,
  PropTypes.string,
  PropTypes.shape({
    xs: PropTypes.number,
    sm: PropTypes.number,
    md: PropTypes.number,
    lg: PropTypes.number
  })
]);

export const getGridSizeObject = size => {
  const completeObject = (typeof size === 'object')
    ? Object.assign({ xs: 12 }, size)
    : { xs: 12, sm: Number(size) };
  return completeObject;
};
